import { BaseLevelDef } from '../types';

export const BASE_LEVELS: BaseLevelDef[] = [
  { level: 1, coinCost: 0, name: 'Tiny Shack' },
  { level: 2, coinCost: 10, name: 'Small Cabin' },
  { level: 3, coinCost: 25, name: 'Cozy House' },
  { level: 4, coinCost: 50, name: 'Big Workshop' },
  { level: 5, coinCost: 100, name: 'Robot HQ' },
];
